import React, { createContext, useContext } from 'react';
import { ApiPendingSection1Repository } from '../../infra/repositories/ApiPendingSection1Repository';
import { FetchPendingSection1ItemsUseCase } from '../../application/use-cases/FetchPendingSection1ItemsUseCase';
import { useHttpClientCore } from '@/shared/infra/http/HttpClientContext';
import { ArchiveI9UseCase } from '@/shared/application/use-cases/ArchiveI9UseCase';
import { ApiArchiveI9Repository } from '@/shared/infra/repositories/ApiArchiveI9Repository';

interface PendingSection1DIContextType {
  fetchPendingSection1ItemsUseCase: FetchPendingSection1ItemsUseCase;
  archiveI9UseCase: ArchiveI9UseCase;
}

const PendingSection1DIContext = createContext<PendingSection1DIContextType | undefined>(undefined);

export const PendingSection1DIContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const httpClient = useHttpClientCore();
  const repository = new ApiPendingSection1Repository(httpClient);
  const fetchPendingSection1ItemsUseCase = new FetchPendingSection1ItemsUseCase(repository);
  const archiveI9UseCase = new ArchiveI9UseCase(new ApiArchiveI9Repository(httpClient));

  return (
    <PendingSection1DIContext.Provider
      value={{ fetchPendingSection1ItemsUseCase, archiveI9UseCase }}
    >
      {children}
    </PendingSection1DIContext.Provider>
  );
};

export const usePendingSection1DIContext = () => {
  const context = useContext(PendingSection1DIContext);
  if (!context) {
    throw new Error('usePendingSection1DIContext must be used within a PendingSection1DIContextProvider');
  }
  return context;
};
